module.exports = __webpack_public_path__ + "img/h_s2e2_thumbnail.ca048a70.png";